module.exports = __webpack_public_path__ + "static/img/movie.7be30d49.png";